
import MatchboxIcon from './assets/favicon.ico';
import MatchboxLogo from './assets/matchbox-logo-white-small.png'
import LoginImage from './assets/trinity1-logo.png';


const SiteData =
  {
    loginTitle: 'Welcome to the Trinity Hall 2020 Open House!',
    loginImagesrc: LoginImage,
    loginImagealt: "Trinity Logo",
    attendeeTitle: 'Trinity Hall 2020 Virtual Open House',
    matchboxLogo: MatchboxIcon,
    matchboxIcon: MatchboxLogo,
    endOfEventPageTitle: 'Trinity Hall Open House 2020',
    matchboxLogoAlt: 'matchbox logo',
    matchboxLogoTitle: 'hello',
    attendantTitle: 'Trinity Hall Event Console',
    titleIndex: 'Trinity Hall Open House',
    thankYouMessageTitle: 'Thank you for joining us at the Trinity Hall Open House',
    auditorium: true,
    generalChatId: 1,
    schemaName: 'trinity'


  };
export default SiteData
